export const TELEMEDICINE_INFO = {
	code: '127304670',
	name: 'Teleconsulta - Digital',
	label: 'Atendimento por vídeo chamada',
	label2: 'Consulta Digital',
	cityName: 'FORTALEZA',
	ufCode: 'CE',
	ufName: 'CEARA',
};
